import { snack } from "components/Snack/Snack";
import CrudPage from "components/CrudPage/CrudPage";
import withRouter from "hoc/withRouter";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import AppSmartForm from "components/AppSmartForm/AppSmartForm";
import roomTypesService from "services/admin/roomTypesService";
import roomsService from "services/admin/roomsService";

const RoomForm = ({
  router: {
    navigate,
    params: { id, hotelID },
  },
  data: { room, roomTypes },
}) => {

  console.log("hotelID: ", hotelID);

  const fieldsWithData = [
    {
      key: "number",
      label: "Номер",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "roomTypeID",
      label: "Тип комнаты",
      required: true,
      inputType: inputTypeEnum.select,
      options: roomTypes ? roomTypes : [],
    },
    // Capacity
    {
      key: "capacity",
      label: "Количество мест",
      required: true,
      inputType: inputTypeEnum.number,
    },    
    {
      key: "hotelID",
      label: "Отель",
      required: true,
      inputType: inputTypeEnum.hidden,
      defaultValue: hotelID,
    }
  ]

  const onSubmit = async (formValues) => {
    try {
      if (room) {
        await roomsService.put(id, formValues)
        snack("Комната обновлен успешно!");
      } else {
        await roomsService.post(formValues)
        snack("Комната создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={room ? 'Редактирование комнаты' : 'Создание комнаты'}>
      <AppSmartForm onSubmit={onSubmit} data={room} fields={fieldsWithData}></AppSmartForm>
    </CrudPage>
  );
};

export default withRouter(
  withRemoteDataAndSpinner(RoomForm, (router) => {
    let requests = {
      roomTypes: () => roomTypesService.getAll(),
    }

    if (router.params.id) {
      requests['room'] = () => roomsService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
